
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';
import { Auth } from 'aws-amplify';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Branding } from '../../branding';
import { generateSession } from "../../common/service";
import Footer from '../../components/Footer/Footer';
import { verifyActivationCode } from '../../components/LandingPage/helpers/activationTokenHelper';
import { setUser } from '../../redux/actions';

const mapStateToProps = (state) => {
	return {
		user: state.app.user,
		lang: state.app.lang,
		tos: state.app.tos
	}
}

const useStyles = makeStyles((theme) => ({
	normalLinkTos: {
		fontSize: 12,
		color: "black",
		'&:hover': {
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	rootGrid: {
		marginTop: theme.spacing(10),
		paddingBottom: theme.spacing(3),
	},
	grid: {
		justifyContent: 'center',
		direction: "row"
	},
	typoToS: {
		paddingTop: theme.spacing(3),

	},
	linkTos: {
		fontSize: 12,
		color: Branding.secondary,
		fontWeight: "bold",
		'&:hover': {
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	midBul: {
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		color: Branding.secondary,
	},
	cardMedia: {
		width: 200,
		height: 90,
		marginBottom: "2%",
		backgroundSize: 'contain',
	},
	message: {
		fontWeight: 'bold',
		marginTop: "2em",
		fontSize: "12px",
		color: Branding.primary
	}
}));

const RedirectPage = (props) => {

	const classes = useStyles();
	const [error, setError] = useState(null);
	const [isLinkAccountFlow] = React.useState(sessionStorage.getItem("link_acc_token") || null);
	const shouldRender = useRef(true);
	if (isLinkAccountFlow) {
		const div = document.querySelector('body')
		if (div) div.style.background = "white";
	}
	React.useEffect(() => {

		if (shouldRender.current) {
			shouldRender.current = false;
			const redirect = async () => {
				try {
					let finalRedirectUrl = await generateSession(props);
					if (!finalRedirectUrl?.error) {
						sessionStorage.removeItem("activationToken");
						sessionStorage.removeItem("link_acc_token")
						window.location = finalRedirectUrl;
					}
					else {
						setError(finalRedirectUrl.response);
					}
				} catch (e) {
					setError(e.message);
				}
				return;
			}

			var checkRedirect = async () => {

				let currentUser = await Auth.currentAuthenticatedUser();

				try {
					if (currentUser && !currentUser.attributes["custom:activation_token"] && sessionStorage.getItem("activationToken")) {
						await verifyActivationCode(sessionStorage.getItem("activationToken"));
						await Auth.updateUserAttributes(props.user, { "custom:activation_token": sessionStorage.getItem("activationToken") });
						// refresh the token after user attribute update
						currentUser = await Auth.currentAuthenticatedUser({ bypassCache: true });
					}
				} catch (e) {
					console.log(JSON.stringify(e))
					alert("Something went wrong " + JSON.stringify(e))
				}

				await redirect();
			}

			checkRedirect();
		}
	}, []);

	return (

		<div>
			{!error ? <Grid
				container
				spacing={0}
				direction="column"
				alignItems="center"
				justifyContent="center"
				className={classes.rootGrid}
			>
				{!isLinkAccountFlow ?
					<CardMedia
						className={classes.cardMedia}
						image={"https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png"}
						title={Branding.appName}
					/>
					: null
				}

				<CircularProgress variant='indeterminate' thickness={3} size={"3em"} />
				<Typography style={{ marginBottom: "2em" }} className={classes.message}> Getting everything ready… </Typography>

			</Grid>
				: null
			}

			{error ?
				<div style={{ justifyContent: 'left', textAlign: "left" }}>
					{error}
				</div>
				:
				null
			}

			{!isLinkAccountFlow && !error ?
				<Footer></Footer>
				: null
			}
		</div>
	)
}

export default connect(mapStateToProps, { setUser })(RedirectPage);